/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Companydetails_Incorporationdate2Inputs */

const ja_company_companydetails_incorporationdate2 = /** @type {(inputs: Company_Companydetails_Incorporationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2016年1月15日`)
};

const en_company_companydetails_incorporationdate2 = /** @type {(inputs: Company_Companydetails_Incorporationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15th January, 2016`)
};

/**
* | output |
* | --- |
* | "15th January, 2016" |
*
* @param {Company_Companydetails_Incorporationdate2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const company_companydetails_incorporationdate2 = /** @type {((inputs?: Company_Companydetails_Incorporationdate2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Companydetails_Incorporationdate2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_company_companydetails_incorporationdate2(inputs)
	return en_company_companydetails_incorporationdate2(inputs)
});
export { company_companydetails_incorporationdate2 as "company_companyDetails_incorporationDate" }